jQuery( function($) {

    //SCROLLING HEADER
    var $header = $('.js-site-header');

    scrollWindow();

    $(window).scroll(function(){
        scrollWindow();
    });

    function scrollWindow() {
        var window_scroll = $(window).scrollTop();

        if ( window_scroll > 0 ) {
            $header.addClass('site-header--scrolling');
        } else {
            $header.removeClass('site-header--scrolling');
        }
    }

    //OPEN SITE MENU
    var $body = $('body');
    var $burger = $('.js-site-header__burguer');
    var $menu = $('.js-site-menu');

    $burger.on('click', function () {
        $body.toggleClass('overflow-hidden');
        $header.toggleClass('open');
        $menu.toggleClass('open');
        $(this).find('.burguer').toggleClass('open');
    });


    /*
    var $link_active = $('.js-site-menu__link.active');

    function matchMedia() {
        if (window.matchMedia('(max-width: 760px)').matches) {
            $link_active.removeClass('active');
        } else {
            $link_active.addClass('active');
        }
    }

    $(window).on('resize', function(){
        matchMedia();
    });

    matchMedia();
    */
});
